import { ScrollArea } from '@ads/components-react';
import type { ProductRevenueData } from '@linka/domain/dtos';
import { useTranslation } from '@linka/i18n';
import { formatMoney, formatNumber } from '@linka/utils';
import { ChartCard, ChartCardContent, ChartCardHeader, ChartCardTitle, ExportChartTriggerButton } from '../components';

interface ProductsTopRevenueProps {
  data: ProductRevenueData[];
}

export const ProductsTopRevenue = ({ data }: ProductsTopRevenueProps) => {
  const t = useTranslation();

  return (
    <ChartCard>
      <ChartCardHeader>
        <ChartCardTitle>{t('dashboard.charts.products-top-revenue')}</ChartCardTitle>
        <ExportChartTriggerButton type='OVERVIEW_PRODUCTS_TOP_REVENUE' />
      </ChartCardHeader>
      {data.length === 0 ? (
        <ChartCardContent className='flex flex-1 items-center justify-center py-xl'>
          <span className='ts-paragraph-xs text-ctx-content-base'>{t('dashboard.charts.no-data')}</span>
        </ChartCardContent>
      ) : (
        <ChartCardContent className='relative min-h-[320px] flex-1'>
          <ScrollArea className='!absolute inset-0'>
            <div className='flex flex-col gap-mini'>
              {data.map((item, index) => (
                <div key={item.productId} className='flex flex-col gap-quark'>
                  <div className='flex items-center justify-between gap-nano'>
                    <span className='ts-paragraph-xs text-ctx-content-title truncate'>
                      {index + 1} · {item.productName}
                    </span>
                    <span className='ts-paragraph-xxs text-ctx-content-base whitespace-nowrap'>
                      {formatMoney(item.revenue)} · {formatNumber(item.revenuePercentage / 100, { style: 'percent' })}
                    </span>
                  </div>
                  <div className='h-nano w-full rounded-pill bg-base-gray-200 overflow-hidden'>
                    <div
                      className='h-full rounded-pill bg-base-brand-400'
                      style={{ width: `${Math.min(item.revenuePercentage, 100)}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </ScrollArea>
        </ChartCardContent>
      )}
    </ChartCard>
  );
};
